/**
 * Copyright 2026 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

import type { MyProfileApiV2 } from '@/features/myProfile';

type VerificationAnalytics = {
  verifiedEmail?: 'verifiedEmail';
  unverifiedEmail?: 'unverifiedEmail';
  verifiedSMS?: 'verifiedSMS';
  unverifiedSMS?: 'unverifiedSMS';
};

export const getVerificationAnalytics = (
  user?: Pick<MyProfileApiV2, 'lastVerifiedEmailTimestamp' | 'lastVerifiedPhoneTimestamp'>,
  verificationOverride?: 'EMAIL' | 'PHONE',
) => {
  if (!user) {
    return {};
  }

  const isEmailVerified =
    Boolean(user.lastVerifiedEmailTimestamp) || verificationOverride === 'EMAIL';
  const isPhoneVerified =
    Boolean(user.lastVerifiedPhoneTimestamp) || verificationOverride === 'PHONE';

  const result: VerificationAnalytics = {};

  if (isEmailVerified) {
    result.verifiedEmail = 'verifiedEmail';
  } else {
    result.unverifiedEmail = 'unverifiedEmail';
  }

  if (isPhoneVerified) {
    result.verifiedSMS = 'verifiedSMS';
  } else {
    result.unverifiedSMS = 'unverifiedSMS';
  }

  return result;
};
